import React from "react";
import PropTypes from 'prop-types';
import Loading from './../assets/images/loading_white.svg';
const CustomButton = (props) => {
    let {loading, content, type, action,block, textWhite, style} = props;
    return(
        <button className={"btn btn-"+type+(block? " btn-block" : "") + (textWhite ? " text-white" : "")}
                onClick={action}
                disabled={loading}
                style={style}
        >
            {loading === true ? <img src={Loading} width={20} /> : content}
        </button>
    )
}

CustomButton.propTypes = {
    loading: PropTypes.bool.isRequired,
    content: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
    block: PropTypes.bool.isRequired
};
export default CustomButton;
